import Resume from '../../images/sethLResume.pdf';

function AboutContent() {
  return (
    <div className = 'about-content-experience'>
      <div className = "about-content-experience-content">
        <div className = "about-content-experience-content-info">
          <span className = "about-content-experience-content-info-subtitle">Experience</span>
          <span className = "about-content-experience-content-info-title">MY EXPERIENCE</span>
          <span className = "about-content-experience-content-info-desc">Hello! My name is Seth LaMar. I am a creative fullstack developer and content editor with a eye for design and a love for creating enjoyable web experiences. </span>
          <a href = {Resume} className = "about-content-experience-content-info-button">Download my resume</a>
        </div>
        <div className = 'about-content-experience-content-experience'>
          <div className = 'about-content-experience-content-experience-item'>
            <div className = 'about-content-experience-content-experience-item-info'><span className = 'about-content-experience-content-experience-item-info-date'>December 2022 - Present</span><span className = 'about-content-experience-content-experience-item-info-company'>- Self Employed</span></div>
            <span className = 'about-content-experience-content-experience-item-title'>FREELANCE WEB DEVELOPER</span>
          </div>
          <div className = 'about-content-experience-content-experience-item'>
            <div className = 'about-content-experience-content-experience-item-info'><span className = 'about-content-experience-content-experience-item-info-date'>Sep 2023 - March 2024</span><span className = 'about-content-experience-content-experience-item-info-company'>- ENGAGEathon</span></div>
            <span className = 'about-content-experience-content-experience-item-title'>FRONTEND DEVELOPER INTERN</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AboutContent;